export const UPLOADED_IMAGE = "UPLOADED_IMAGE";
